const SurveyType = {
  NORMAL: 1,
  UNIQUE: 2,
  UNIVERSAL: 3
} as const;

export type SurveyTypeValue = (typeof SurveyType)[keyof typeof SurveyType];

export default SurveyType;
